<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  export default {
    name: 'App',
    computed: {},
    watch: {},
    data() {
      return {};
    },
    methods: {
    }
  };
</script>

<style>
  @import '//at.alicdn.com/t/font_1733012_3122mc523yk.css';

  .scrollbar1{
    overflow-y: auto;
  }

  .scrollbar1::-webkit-scrollbar {
    width: 6px; /*对垂直流动条有效*/
    height: 6px; /*对水平流动条有效*/
  }
  /*滚动条里面轨道*/
  .scrollbar1::-webkit-scrollbar-track{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.2);
    background-color:#73d2f3;
    border: solid 1px #bfcbd9;
    border-radius: 1px;
  }
  /* 滑块 */
  .scrollbar1::-webkit-scrollbar-thumb{
    border-radius: 4px;
    background-color:#B5D6E6;
  }

  /*定义两端按钮的样式*/
  .scrollbar1::-webkit-scrollbar-button {
    height:6px;
    background-color:#bfcbd9;
  }

  /*定义右下角汇合处的样式*/
  .scrollbar1::-webkit-scrollbar-corner {
    background:#ffffff;
  }

  .scrollbar1::-webkit-scrollbar-track-piece {
    background-color: #ffffff;
  }

  .scrollbar1.bar20::-webkit-scrollbar {
    width: 20px; /*对垂直流动条有效*/
    height: 20px;
  }
  div,p,span{
    letter-spacing: 1px;
  }
  body{
    min-height: 100%;
    background-color: #f6f6f6;
  }

  .box-search{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: left;
    -ms-flex-pack: left;
    justify-content: left;
  }
  .box-search-item{
    padding: 5px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background-color: #E2F4FF;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue